
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.05 17.95l-6.425-6.425c-.5.433-1.08.767-1.738 1a6.059 6.059 0 01-2.037.35c-1.7 0-3.142-.588-4.325-1.762C1.342 9.937.75 8.508.75 6.825c0-1.7.592-3.138 1.775-4.313C3.708 1.337 5.14.75 6.825.75c1.683 0 3.116.587 4.3 1.762C12.308 3.687 12.9 5.125 12.9 6.825c0 .7-.121 1.38-.363 2.037a5.856 5.856 0 01-1.012 1.763l6.425 6.4-.9.925zM6.825 11.625c1.35 0 2.487-.467 3.412-1.4.925-.934 1.388-2.067 1.388-3.4 0-1.35-.463-2.492-1.388-3.425C9.312 2.466 8.175 2 6.825 2c-1.334 0-2.471.466-3.413 1.4C2.471 4.333 2 5.475 2 6.825c0 1.333.47 2.466 1.412 3.4.942.933 2.08 1.4 3.413 1.4z","fill":"currentColor"}})])
          )
        }
      }
    